module.exports = __webpack_public_path__ + "static/media/iconmonstr-github-4.0bbe4809.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/iconmonstr-github-4.svg
// module id = 239
// module chunks = 0